import Model from '@/lib/data/Model';
import AccessRoleFunction from '@/data/AccessRoleFunction';

class AccessRole extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'name',
        {
            name: 'functions',
            association: {
                type: 'many',
                model: AccessRoleFunction,
            },
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default AccessRole;
